import { isPublicPost } from "./blog-visibility";
import type { BlogPostSummary } from "./blog";
import type { SiteContext } from "./site";

// Each locale's summary is generated into its own sibling file (see
// scripts/generate-latest-posts.mjs), so the bundler splits them into separate
// chunks and the home page downloads only the active locale's ~3 post cards —
// never ./blog's yaml + eager glob of every locale's full Markdown. Mirrors the
// import.meta.glob pattern src/lib/search.ts already uses for search-index.
const postLoaders = import.meta.glob<{ posts: BlogPostSummary[] }>(
  "../generated/latest-posts.*.ts",
);

const SHOW_PREVIEW_POSTS =
  import.meta.env.DEV ||
  (import.meta.env as unknown as Record<string, string | undefined>).VITE_INCLUDE_DRAFTS === "true";

export async function loadLatestPosts(site: SiteContext): Promise<BlogPostSummary[]> {
  const loader = postLoaders[`../generated/latest-posts.${site.locale}.ts`];
  if (!loader) return [];
  const { posts } = await loader();
  return posts
    .filter((post) => post.markets.includes(site.market))
    .filter((post) => SHOW_PREVIEW_POSTS || isPublicPost(post))
    .slice(0, 3);
}
